import { useEffect, useState } from 'react';
import { FieldComponentProps, TuaPayLoanIframeMessage } from '../../../types';
import { useDataContext } from '../../../context/dataContainer';
import { createTuaPayUrl, performTuaPayTransaction } from '../../../api';
import { useTranslation } from 'react-i18next';
import { getLoanRequestDetails, preparePaymentData } from '../../../utils';


export const TuaPayFrameContainer: React.FC<FieldComponentProps> = ({
  toggleFetching, openTuaPayFrame,
}: FieldComponentProps) => {
  const [launchUrl, setLaunchUrl] = useState('');

  const {
    clientId, session, payPage, libInitializeId,
  } = useDataContext();

  const { t: tErrors } = useTranslation('errors');

  const handlePayment = async (message: TuaPayLoanIframeMessage) => {
    try {
      const { account, shipping, customFields } = await getLoanRequestDetails({
        sessionId: session,
        libInitializeId,
      });
      const paymentData = preparePaymentData(message);
      await performTuaPayTransaction(
        {
          account,
          shipping,
          loanInfo: paymentData,
          customFields,
        }, {
          payPage,
          session,
          clientId,
        }
      );

      // const isSuccess = response === true;

      // window.parent.postMessage({
      //   sessionId: session,
      //   libInitializeId,
      //   action: MessageActions.TUAPAY_LOAN_RESULT,
      //   data: {
      //     success: isSuccess,
      //     data: response,
      //   },
      // }, '*');
    } catch (error) {
      // window.parent.postMessage({
      //   sessionId: session,
      //   libInitializeId,
      //   action: MessageActions.TUAPAY_LOAN_RESULT,
      //   data: {
      //     success: false,
      //     error: tErrors((error as Error).message),
      //   },
      // }, '*');
    }
  };

  const onMessage = (event: MessageEvent) => {
    if (!event.data) {
      return;
    }

    try {
      const message =
        typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (message.command === 'close') {
        window.parent.postMessage({ sessionId: session, libInitializeId, ...message }, '*');
      } else if (message.command === 'loan_complete') {
        window.parent.postMessage({ sessionId: session, libInitializeId, ...message }, '*');
        handlePayment(message);
      } else if (message.command === 'application_complete') {
        window.parent.postMessage({ sessionId: session, libInitializeId, ...message }, '*');
      }
    } catch (error) {
      window.parent.postMessage({ sessionId: session, libInitializeId, error }, '*');
    }
  };

  useEffect(() => {
    if (!clientId || !session || !payPage) {
      openTuaPayFrame(undefined, new Error('Missing TuaPay parameters'));
      return;
    }
  
    toggleFetching(true);
    createTuaPayUrl({ clientId, payPageId: payPage, session })
      .then((response) => {
        if (response.isSuccess && response.launchUrl) {
          setLaunchUrl(response.launchUrl);
          openTuaPayFrame(response.launchUrl);
        } else {
          openTuaPayFrame(undefined, tErrors('tuapay_launch_url_error'));
        }
      })
      .catch((error) => {
        openTuaPayFrame(undefined, tErrors((error as Error).message));
      });
  }, []);

  useEffect(() => {
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  if (!launchUrl) {
    return <></>;
  }

  return (
    <iframe
      src={launchUrl}
      width="100%"
      height="100%"
      title="TuaPay"
      style={{ border: 'none' }}
      id="tuapay_frame"
    ></iframe>
  );
};
